import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { NavigationItemStore } from '@seedlang/stores';
import { AppUI } from '@seedlang/state';
import NavigationItemPathWarning from './navigation_item_path_warning';
import Grid from 'components/layout/grid';
import ButtonPrimary from 'components/button/button_primary';

@observer
class NavigationItemCreate extends React.Component {
  @observable name = '';
  @observable path = '';

  onClick() {
    const data = Object.assign({
      name: this.refs.name.value,
      path: this.refs.path.value,
      site_id: this.props.siteId,
    }, this.props.data);

    NavigationItemStore.create({ data: data }, this.props.afterCreate());
    this.refs.name.value = '';
    this.refs.path.value = '';
  }

  componentDidMount() {
    AppUI.pageStore.getIndex();
  }

  render() {
    return (
      <div className='nav-item-create'>
        <Grid columns={3} gap='sm'>
          <input
            placeholder='Add a name'
            ref='name'
            value={this.name}
            onChange={e => this.name = e.target.value}
          />
          <input
            placeholder='Add a path'
            ref='path'
            value={this.path}
            onChange={e => this.path = e.target.value}
          />
          <ButtonPrimary
            onClick={this.onClick.bind(this)}
            disabled={this.name === '' || this.path === ''}
          >
            Create
          </ButtonPrimary>
        </Grid>
        {
          this.path &&
            <NavigationItemPathWarning
              path={this.path}
            />
        }
      </div>
    );
  }
}

export default NavigationItemCreate;
